<template>
  <div>
    <div v-if="!subjectSets && receiveWarningType == 1">
      <van-cell-group>
        <van-switch-cell title-class="titlecss" label="开启后，在设定时间段内将不会接收通知信息。" v-model="swichValue" title="消息免打扰" @change="setNoBotherTime()" />
        <p></p>
        </van-cell-group>
        <van-cell-group  v-if="isOpen == '1'">
          <van-cell title="开始时间" title-class="titlecss" :value="btime" @click="showTimeWary('btimePopup')" />
        </van-cell-group>
        <van-cell-group  v-if="isOpen == '1'">
          <van-cell title="结束时间" title-class="titlecss" :value="etime" @click="showTimeWary('etimePopup')" />
      </van-cell-group>
        <!--开始时间-->
      <van-popup
        v-model="btimePopup"
        position="bottom">
        <van-datetime-picker
          v-model="btime_set"
          type="time"
          @confirm="setTime('btime')"
          @cancel="cancelSetTime('btimePopup')"
        />
      </van-popup>
      <!--结束时间-->
      <van-popup
        v-model="etimePopup"
        position="bottom">
        <van-datetime-picker
          v-model="etime_set"
          type="time"
          @confirm="setTime('etime')"
          @cancel="cancelSetTime('etimePopup')"
        />
      </van-popup>
      <div v-if="userType == 'v4'">
        <van-switch-cell title-class="titlecss" label="" v-model="rankWarningOpen" @change="setNoWarningTime" title="接收榜单预警"  />
      </div>
      <div>
        <van-switch-cell title-class="titlecss" label="" v-model="predictHotOpen" @change="setPredictHotOpen" title="接收预测热点预警"  />
      </div>
      <div v-if="userType == 'v4'" class="subject-set-wary" @click.stop="gotoSubjectSet">
        接收专题 <i></i>
      </div>
    </div>
    <!-- 专题 -->
    <div v-if="subjectSets && receiveWarningType == 1">
       <setTree></setTree>
    </div>
    <!-- 专题end -->
    <!-- 提示 -->
    <div v-if="receiveWarningType == 2" class="is-set-data">
      <div>
        <img src="../../../assets/images/set/noSetIco.svg" />
        <p>您的账号在微信公众号端暂无设置权限</p>
      </div>
    </div>
    <!-- 提示end -->
  </div>
</template>
<script>
  import { SwitchCell,CellGroup,Cell,Popup,DatetimePicker } from 'vant';
  import {updateDisturbanceFreeTime,getDisturbanceFreeTime} from '@/api/pushwarning' 
  import {getUserInfo} from '@/api/wechat' 
  import setTree from '@/pages/pushwarning/setTree/setTree'
  export default {
    components: {
      "van-switch-cell": SwitchCell,
      "van-cell-group": CellGroup,
      "van-cell": Cell,
      "van-datetime-picker": DatetimePicker,
      "van-popup": Popup,
      setTree:setTree
    },
    data(){
      return {
        receiveWarningType:'',
        userAccountType:'',
        userType:'',
        subjectSets:false,
        swichValue: '0',
        isOpen:'0',
        btime:'00:00',
        btime_set:'00:00',
        etime:'00:00',
        etime_set:'00:00',
        btimePopup:false,
        etimePopup:false,
        rankWarningOpen:true,
        predictHotOpen: false  //预测热点的推送开关 0 关闭 1 开启
      }
    },
    methods:{
      //获得用户信息
      getUserData(){
        getUserInfo().then(res=>{ 
          let {data,code} = res.data
          if(code === 200){
            this.userAccountType = data.userAccountType
            this.userType = data.userType
            this.receiveWarningType = data.receiveWarningType
          }  
        })
      },
      //获取设置信息
      getInfo(){
        getDisturbanceFreeTime().then(res=>{
          if(res.data.result && res.data.result.data){
            let d = res.data.result.data;
            console.log(d);
            this.btime = d.bTime;
            this.btime_set = d.bTime;
            this.etime = d.eTime;
            this.etime_set = d.eTime;
            this.isOpen = d.isOpen;
            this.rankWarningOpen = d.rankWarningOpen === 1 ? true : false;
            this.predictHotOpen = d.predictHotOpen === 1 ? true : false;
            this.swichValue = this.isOpen == 1 ? true:false;
          }
        }).catch(err=>{
          console.log(err);
        })
      },
      //更设置
      updateInfo(){
        let p = {
          bTime:this.btime,
          eTime:this.etime,
          isOpen:this.isOpen,
          rankWarningOpen:this.rankWarningOpen ? 1 : 0,
          predictHotOpen: this.predictHotOpen ? 1 : 0
        }
        updateDisturbanceFreeTime(p).then(res=>{
          console.log(res);
        }).catch(err=>{
          console.log(err)
        })
      },
      //设置时间
      setTime(m){ 
        this[m] = this[m+"_set"];
        this[m+"Popup"] = false;
        this.updateInfo();
      },
      //取消弹层
      cancelSetTime(m){
        this[m] = false;
        console.log(this.btime);
      },
      //显示时间插件
      showTimeWary(m){
        this[m] = true;
      },
      //关闭开启设置
      setNoBotherTime(){
        if(this.isOpen == '1'){
          this.isOpen = '0';
        }else{
          this.isOpen = '1';
        } 
        this.updateInfo();
      },
      //预测热点预警
      setPredictHotOpen() {
        this.updateInfo();
      },
      //关闭榜单
      setNoWarningTime(){
        this.updateInfo();
      },
      //跳转专题设置
      gotoSubjectSet(){
        // this.$router.push('/setTree')
        this.subjectSets = true
      }, 
    },
    mounted(){
      //获得用户信息
      this.getUserData()
      //消息免打扰时间
      this.getInfo();
    },
  }
</script>
<style scoped>
  @import url("./pushSet.css");
</style>
